import React from 'react';
import { Box, Link } from '@chakra-ui/react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import Seo from './Seo';

export default function Layout({
  title,
  description,
  image,
  whatsappMessage,
  seoChildren,
  children,
}) {
  return (
    <>
      <Seo title={title} description={description} image={image}>
        {seoChildren}
      </Seo>

      <Link
        href="#contenido"
        position="absolute"
        left="-9999px"
        zIndex="skipLink"
        bg="brand.700"
        color="white"
        px={4}
        py={3}
        _focus={{ left: 4, top: 4 }}
      >
        Saltar al contenido
      </Link>

      <TopBar />
      <Navbar />

      <Box as="main" id="contenido" tabIndex={-1} outline="none">
        {children}
      </Box>

      <Footer />
      <WhatsAppButton message={whatsappMessage} />
    </>
  );
}
